import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-btn-more',
  templateUrl: './btn-more.component.html',
  styleUrls: ['./btn-more.component.scss']
})
export class BtnMoreComponent implements OnInit {

  @Input() href: any;
  @Input() title: any;

  constructor() { }

  ngOnInit() {
  }

}